var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgPricing5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 895,
    viewBox: "0 0 1911 895",
    width: 1911,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 13,
      fill: "none",
      fillRule: "evenodd",
      opacity: 0.196731,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(6 7)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1903 317v-168.319055c0-32.96126-26.868-59.680945-60-59.680945s-60 26.719685-60 59.680945v26.053039",
    stroke: "#fb6340"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1773.98822 725c0 33.688911 26.87155 61 60.01192 61s59.99986-27.311089 59.99986-61-26.85949-61-59.99986-61h-201.00014",
    stroke: "#2dce89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1803.64324 582c55.98549 0 101.35676-46.115088 101.35676-103s-45.37127-103-101.35676-103h-265.64324",
    stroke: "#2dce89",
    transform: "matrix(1 0 0 -1 0 958)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1840 450h-84.00679c-60.75074 0-109.99321 49.69663-109.99321 111",
    stroke: "#fb6340"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m990 138.906103c0 33.188658 26.86303 60.093897 60 60.093897s60-26.905239 60-60.093897v-67.906103",
    stroke: "#2dce89",
    transform: "matrix(-1 0 0 -1 2100 270)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m1590 72h-196.37288c-38.45397 0-69.62712 30.444655-69.62712 68",
    stroke: "#2dce89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m701.840065 198.95057h-10.696724c-31.558941 0-57.143341-25.617864-57.143341-57.204004 0-31.598174 25.5844-57.2160376 57.143341-57.2160376h127.579465c46.630505 0 84.432006-37.8432045 84.432006-84.5305284",
    stroke: "#fb6340",
    transform: "matrix(-1 0 0 1 1537.154812 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m1494.84006 239h-10.69672c-31.55894 0-57.14334-25.617864-57.14334-57.204005 0-31.598173 25.5844-57.216037 57.14334-57.216037h127.57947c46.6305 0 84.432-37.8432045 84.432-84.5305283",
    stroke: "#fb6340"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 576,
    cy: 134.5,
    rx: 58,
    ry: 57.5,
    stroke: "#f5365c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 152,
    r: 63,
    stroke: "#2dce89"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m1212.5 82c-31.75677 0-57.5 25.743053-57.5 57.5s25.74323 57.5 57.5 57.5 57.5-25.743053 57.5-57.5v-57.5",
    stroke: "#2dce89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m231 139.5c0 42.249516 34.026457 76.5 76 76.5s76-34.250484 76-76.5c0-42.2497547-34.026457-76.5-76-76.5h-76",
    stroke: "#f5365c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m67.5 745.5824c-36.7269315 0-66.5-29.4552-66.5-65.7912s29.7730685-65.7912 66.5-65.7912c36.727171 0 66.5 29.4552 66.5 65.7912v201.2088",
    stroke: "#2dce89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m58.5 447.708075c-31.7564115 0-57.5 25.360695-57.5 56.645962s25.7435885 56.645963 57.5 56.645963 57.5-25.360696 57.5-56.645963v-231.354037",
    stroke: "#fb6340"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m455 216v-91.117879c0-52.4636362 40.9752-96.4124846 96-107.882121",
    stroke: "#2dce89"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m36.5 205v184",
    stroke: "#2dce89"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m1843 246.9208v20.2824c0 28.6068-23.26343 51.7968-51.94256 51.7968-28.69116 0-51.95459-23.19-51.95459-51.7968v-16.8c0-28.3896-23.08291-51.4032-51.54541-51.4032-28.47453 0-51.55744 23.0136-51.55744 51.4032v20.676",
    stroke: "#f5365c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPricing5);
export default __webpack_public_path__ + "static/media/bg_pricing5.76a702f77b42748f129f2bdd4fee330f.svg";
export { ForwardRef as ReactComponent };